import UpdatedMainLayout from 'src/layouts/UpdatedMainLayout/UpdatedMainLayout'
import EditWebsiteRest from 'src/components/EditWebsiteRest'
import { Link } from 'react-router-dom'

const EditWebsitePage = ({ role, editId, user }) => {
  if (role != 1) {
    return (
      <UpdatedMainLayout user={user}>
        <h1>sorry, you are not allowed to view this page</h1>
      </UpdatedMainLayout>
    )
  }
  return (
    <UpdatedMainLayout user={user}>
      <Link
        to={'/websites'}
        className="bg-teal-500 text-white p-2 cursor-pointer px-4 py-1 ml-3"
      >
        Back
      </Link>
      <EditWebsiteRest id={editId} />
    </UpdatedMainLayout>
  )
}

export default EditWebsitePage
